import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ThreadService } from 'src/app/services/thread/thread.service';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-fixes-subscription-expired',
  templateUrl: './fixes-subscription-expired.component.html',
  styleUrls: ['./fixes-subscription-expired.component.scss']
})
export class FixesSubscriptionExpiredComponent implements OnInit {
  public user: any;
  public domainId: any;
  @Input() expiredSubscription;
  apiKey = 'dG9wZml4MTIz';
  public productsList=[];
  public productInfo;
  
  @Input() subscriptionInfo;
  @Input() subscribedProduct;
  @Input() section: string = '0';
  @Output() expServices: EventEmitter<any> = new EventEmitter();
  public renewArr = ['incomplete_expired','expired'];
  public cancelArr = ['canceled'];

  constructor(

    private authenticationService: AuthenticationService,
    private threadApi: ThreadService,

  ) { }

  ngOnInit(): void {
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;

    const apiFormData = new FormData();
    apiFormData.append('apiKey', this.apiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('countryId', '');
    apiFormData.append('userId', this.user.Userid);
    apiFormData.append('loginId', this.user.Userid);
    apiFormData.append('technicianId', '');
    forkJoin([
      this.threadApi.apiGetProducts({ domainId: this.domainId }),
     
    ]).pipe(map(([products]) => {
      return {
        products: products,
      
      };
    })).subscribe(res => {
     
      if (res.products.status == 'Success') {
        this.productsList = res.products.data.data;
        if(this.productsList && this.productsList.length>0)
        {
          this.productInfo=this.productsList[0];
        }
        
        console.log(this.productsList);
        
      }
    });

  }

  goToAccountSubscription() {
    this.expServices.emit(true);
  }

  closePopup(){
    this.expServices.emit(false);
  }
}
